import {ProductExDetailType} from "../interface";

interface PropsType {
    product: ProductExDetailType
}

export default function Section1({product}: PropsType) {
    const productDetail = product.productDetail

    return <>
        <h5 className="subheading">기본정보</h5>
        <table className="table table-bordered my_table table_detail">
            <tbody>
            <tr className="h-166px">
                <th style={{width: "16.66%"}}>상품정보</th>
                <td colSpan={3}>
                    {/* TODO: vendor-category로 추정되는데 일단 이대로 냅둠 > 미정 상태 */}
                    <div className="line0">
                        {productDetail.majorCategory !== "" && `[${productDetail.majorCategory}]`} {productDetail.subCategory}
                    </div>
                    <div className="line1">{productDetail.newTxtNmItem}</div>
                    <div className="line2">{productDetail.newTxtStndItem}</div>
                    <div className="line3_lg">{productDetail.productExplain}</div>
                </td>
            </tr>
            <tr>
                <th>생성일자</th>
                <td style={{width: "31.3%"}}>{productDetail.createdon}</td>
                <th style={{width: "16.66%"}}>생성자</th>
                <td style={{width: "31.3%"}}>{productDetail.nameOfCreator}</td>
            </tr>
            </tbody>
        </table>
    </>
}